import { render, staticRenderFns } from "./TeacherDetail.vue?vue&type=template&id=0542a6d8&scoped=true&"
import script from "./TeacherDetail.vue?vue&type=script&lang=js&"
export * from "./TeacherDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TeacherDetail.vue?vue&type=style&index=1&id=0542a6d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0542a6d8",
  null
  
)

export default component.exports